<div class="flex flex-col align-middle relative items-center text-slate-900 hover:cursor-default">
    <button (click)="onCopyDeckClicked()">
        <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
            <title>Copy</title>
            @if (isVisible()) {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="closeSvgIcon" />
            } @else {
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="copySvgIcon" />
            }
        </svg>
    </button>
    @if (isVisible()) {
        <div #dialog class="absolute w-[350px] top-[34px] right-0 sm:right-[-6px] bg-slate-100 z-30 shadow rounded-lg">
            <div class="flex flex-col">
                @if (isReady()) {
                    <div class="flex flex-col grow pr-2">
                        <!-- Name -->
                        <div class="grid grid-cols-3">
                            <div class="text-right p-2 pt-3 border-r">Name</div>
                            <div class="p-1 pt-2 col-span-2">
                                <input #nameInput class="bg-slate-50 shadow-sm w-full p-1 pl-2 disabled:text-slate-400" [attr.value]="deck.name">
                            </div>
                        </div>
                        <!-- Visibility -->
                        <div class="grid grid-cols-3">
                            <div class="text-right p-2 border-r">Visibility</div>
                            <div class="p-1 col-span-2">
                                <select #visibilityInput class="p-1 bg-slate-50 w-full shadow-sm disabled:text-slate-400">
                                    @for (visibilityType of visibilityTypes ; track visibilityType[0]) {
                                        <option value="{{ visibilityType[0] }}" [attr.selected]="visibilityType[0] === deck.visibility ? true : null">{{ visibilityType[1] }}</option>
                                    }
                                </select>
                            </div>
                        </div>
                        <!-- Group -->
                        <div class="grid grid-cols-3">
                            <div class="text-right p-2 pt-3 border-r">Deck Group</div>
                            <div class="p-1 pt-2 col-span-2">
                                <input #groupInput class="bg-slate-50 shadow-sm w-full p-1 pl-2 disabled:text-slate-400" value="Default">
                            </div>
                        </div>
                        <!-- Color -->
                        <div class="grid grid-cols-3">
                            <div class="text-right p-2 border-r">Banner Color</div>
                            <div class="p-2 col-span-2 flex flex-row gap-2 items-center align-middle">
                                <div class="flex align-middle items-center">
                                    <label class="w-5 h-5 rounded-sm shadow-sm" [style.background-color]="deckPreviewColor">
                                        <input #colorInput class="invisible" type="color" size="0" width="0" height="0" [attr.value]="deckPreviewColor" (change)="onColorChange(colorInput.value)">
                                    </label>
                                </div>
                                <div class="grow">{{ deckPreviewColor }}</div>
                                @if (prevColor) {
                                    <div class="pr-7">
                                        <button (click)="onUndoColorClicked($event)" class="w-5 h-5 p-1">
                                            <svg class="w-4 h-4 fill-none stroke-ponder hover:stroke-ponder-link" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="2">
                                                <title>Undo</title>
                                                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="undoSvgIcon" />
                                            </svg>
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <!-- Card Action -->
                        <div class="grid grid-cols-3">
                            <div class="text-right p-2 border-r">Card Action</div>
                            <div class="p-1 col-span-2">
                                <select #actionInput class="p-1 bg-slate-50 w-full shadow-sm disabled:text-slate-400">
                                    <option value="none">Add None to Collection</option>
                                    <option value="all">Add All to Collection</option>
                                    <option value="new">Add New to Collection</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="grid grid-cols-2 text-slate-50 stroke-slate-50 bg-ponder-xlight p-2 rounded-b">
                        <button (click)="onCancelClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                            <div>
                                Cancel
                            </div>
                        </button>
                        <button (click)="onConfirmCopyClicked()" class="flex flex-row gap-2 items-center align-middle justify-center group hover:cursor-pointer hover:text-ponder-bright hover:stroke-ponder-bright">
                            <div>
                                <svg class="w-5 h-5 fill-none " xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5">
                                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="copySvgIcon" />
                                </svg>
                            </div>
                            <div>
                                Copy
                            </div>
                        </button>
                    </div>
                }
                @else if (isCopying()) {
                    <div class="flex flex-col bg-slate-100 rounded grow p-3 gap-2 items-center justify-center align-middle text-ponder-light shadow">
                        <div class="flex grow items-center justify-center align-middle">
                            <svg class="animate-spin h-14 w-14" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle class="opacity-10 stroke-ponder-link" cx="12" cy="12" r="10" stroke-width="2"></circle>
                                <path class="opacity-75 fill-ponder-link stroke-transparent" [attr.d]="busySpinSvg"></path>
                            </svg>
                        </div>
                        <div class="opacity-70">
                            Copying. Please wait ...
                        </div>
                    </div>
                }
                @else if (isDoneSuccess()) {
                    <div class="flex flex-col bg-slate-100 rounded grow p-3 gap-2 items-center justify-center align-middle shadow">
                        <div>
                            Copy Complete!
                        </div>
                        <div>
                            <a [attr.href]="deckUrl" class="text-ponder-link">Click here to view your new deck.</a>
                        </div>
                    </div>
                }
                @else if (isDoneFailure()) {
                    <div class="flex flex-col bg-slate-100 rounded grow p-3 gap-2 items-center justify-center align-middle text-red-600 border border-red-600 shadow">
                        <div>
                            {{ errorMessage ?? "Something went wrong! Please close and try again." }}
                        </div>
                    </div>
                }
            </div>
        </div>
    }
</div>